import type { MaterialStore } from '@api/warehouse-ops';
import VendorReceiveContainer from '@components/containers/vendorReceive';
import { Modal, Text } from '@mantine/core';
import type { FC } from 'react';

interface Props {
    store: MaterialStore | null;
    onClose: () => void;
    onSaved: () => void;
}

/**
 * Step two of Add GRN for raw and packaging material: the factories' own receive grid, wide,
 * writing into the store. Same order, cap, QC, reason and action; it files a Warehouse Ops GRN.
 */
const StoreReceiveModal: FC<Props> = ({ store, onClose, onSaved }) => (
    <Modal
        opened={!!store}
        onClose={onClose}
        size="90vw"
        centered
        closeOnClickOutside={false}
        title={
            <Text fz={16} fw={600}>
                Add GRN · RM/PM · {store?.name}
            </Text>
        }
    >
        {store && <VendorReceiveContainer materialStoreId={store.warehouseId} embedded onSaved={onSaved} />}
    </Modal>
);

export default StoreReceiveModal;
